export default {
  fetchDataFailed:
    "Error al cargar los datos del usuario, por favor intente nuevamente o contacte al soporte",
  password_changed_other_tab: "Contraseña actualizada en otra pestaña",
  profile_updated_other_tab: "Perfil actualizado en otra pestaña",
  report_updated_other_tab: "La configuración del informe ha sido actualizada en otra pestaña",
  logged_out_other_tab: "Ha sido desconectado en otra pestaña",
  oauth: {
    processing: "Procesando solicitud de inicio de sesión...",
  },
  ticket: {
    modal_title: "Crear ticket",
    not_logged_in: "Por favor, inicie sesión primero",
    login_required:
      "Para crear un ticket, debe estar conectado a su cuenta. ¿Desea ir a la página de inicio de sesión?",
    go_to_login: "Ir a iniciar sesión",
    submit_success:
      "¡Ticket enviado con éxito! Nuestro equipo de soporte responderá dentro de 24-48 horas.",
    email: "Correo electrónico",
    email_placeholder: "Por favor, ingrese su correo electrónico",
    type: "Tipo de problema",
    type_placeholder: "Por favor, seleccione el tipo de problema",
    subject: "Asunto",
    subject_placeholder: "Por favor, ingrese un asunto para su ticket (5-100 caracteres)",
    description: "Descripción del problema",
    description_placeholder: "Por favor, describa el problema en detalle",
    submit_ticket: "Enviar ticket",
    submit_failed: "¡Error al enviar el ticket!",
    email_send_failed_title: "Problema de notificación por correo",
    email_send_failed_desc:
      "Su ticket ha sido enviado con éxito, pero hemos detectado problemas al enviar la notificación por correo. Nuestro equipo de soporte procesará su solicitud de todos modos.",
  },
};
